import { render, staticRenderFns } from "./EstadoDeudaCrud.vue?vue&type=template&id=5ac60943"
import script from "./EstadoDeudaCrud.vue?vue&type=script&lang=js"
export * from "./EstadoDeudaCrud.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports